import { hideSplitCostBudgetModal, splitCostBudgetModalSelector } from '@/features/offers/slices/offerModal.slice'
import React, { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Input,
  Select,
  Box,
  FormControl,
  FormLabel,
  Text,
} from '@chakra-ui/react'
import { CostBudgetType, CostBudgetTypeLabel } from '@eapproval/offer-shared'
import { DeleteButton } from '@/components/Elements/Button'
import useOfferSourcing from '@/features/offers/hooks/useOfferSourcing'
import { toast } from 'react-toastify'

const SplitCostBudgetModal = () => {
  const { show, originalCostBudgetName, originalCostBudgetRFQCode, offerId, costBudgetIndex } =
    useSelector(splitCostBudgetModalSelector)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [newCostBudgets, setNewCostBudgets] = useState([
    {
      name: '',
      type: '',
    },
    {
      name: '',
      type: '',
    },
  ])

  const dispatch = useDispatch()

  const { useSplitCostBudget } = useOfferSourcing()

  const splitCostBudget = useSplitCostBudget()

  const handleSubmit = async () => {
    try {
      //Validate new cost bduget Index

      if (newCostBudgets.some((costBudget) => costBudget.name === '' || costBudget.type === '')) {
        throw new Error('Please fill in all new cost budget name.')
      }
      const res = await splitCostBudget.mutateAsync({
        offerId: offerId,
        costBudgetIndex: costBudgetIndex,
        newCostBudgets: newCostBudgets,
      })

      dispatch(hideSplitCostBudgetModal())
    } catch (error) {
      console.error('Error splitting cost budget:', error)
      toast.error(error.message)
    }
  }

  const handleModalClose = useCallback(() => {
    dispatch(hideSplitCostBudgetModal())
  }, [dispatch])

  const handleAddSplitCostBudget = () => {
    setNewCostBudgets((prev) => [
      ...prev,
      {
        name: '',
        type: '',
      },
    ])
  }
  const handleDeleteNewCostBudget = (index) => {
    setNewCostBudgets((prev) => {
      const newCostBudgets = [...prev]
      newCostBudgets.splice(index, 1)
      return newCostBudgets
    })
  }
  const handleInputChange = (index, field, value) => {
    setNewCostBudgets((prev) => {
      const updated = [...prev]
      updated[index] = { ...updated[index], [field]: value }
      return updated
    })
  }

  return (
    <Modal isOpen={show} onClose={handleModalClose} size="xl">
      <ModalOverlay />
      <ModalContent maxW="60%">
        <ModalHeader>
          Split Cost Budget: [{originalCostBudgetRFQCode}] {originalCostBudgetName}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Flex direction={'column'} gap="2">
            <Flex justifyContent={'flex-end'}>
              <Button colorScheme="green" onClick={handleAddSplitCostBudget}>
                Add
              </Button>
            </Flex>
            {newCostBudgets.map((costBudget, index) => (
              <Flex gap="2" alignItems={'center'} key={index}>
                {index !== 0 ? <DeleteButton onClick={() => handleDeleteNewCostBudget(index)} /> : <Box w="45px"></Box>}

                <FormControl whiteSpace="nowrap" as={Flex} alignItems={'center'}>
                  <FormLabel>
                    {originalCostBudgetRFQCode}-{String.fromCharCode(65 + index)}
                  </FormLabel>
                  <Input value={costBudget.name} onChange={(e) => handleInputChange(index, 'name', e.target.value)} />
                </FormControl>
                <FormControl whiteSpace="nowrap" as={Flex} alignItems={'center'}>
                  <FormLabel>Type: </FormLabel>
                  <Select
                    value={costBudget.type}
                    onChange={(e) => handleInputChange(index, 'type', e.target.value)}
                    placeholder="Select"
                  >
                    {Object.values(CostBudgetType).map((type) => {
                      return (
                        <option key={type} value={type}>
                          {CostBudgetTypeLabel[type]}
                        </option>
                      )
                    })}
                  </Select>
                </FormControl>
              </Flex>
            ))}
          </Flex>
        </ModalBody>

        <ModalFooter>
          <Flex gap={2}>
            <Button colorScheme="blue" isLoading={isSubmitting} loadingText="Confirming" onClick={handleSubmit}>
              Save
            </Button>
            <Button variant="ghost" mr={3} onClick={handleModalClose}>
              Cancel
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default SplitCostBudgetModal
